module.exports = "https://www.gc-pro.gnp.com.mx/a4bdb9df6fafdd13d19980f3806295f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-registro-seguridad.svg
// module id = 1837
// module chunks = 0